import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import SearchableDropdown from "../AuthorUIComponents/SearchableDropdown";
import LessonCard from "../LessonCard";
import {
  sortableHandle,
  sortableContainer,
  sortableElement
} from "react-sortable-hoc";

import arrayMove from "array-move";

import DirectiveCard from "./DirectiveCard";
import DeleteButton from "../AuthorUIComponents/DeleteButton";

const handleSortStart = ({ node }) => {
  // const directive = document
  //   .getElementById("directive-container")
  // const containerWidth = document.getElementsByClassName(
  //   "items-bank-left-container"
  // )[0].offsetWidth;
  // let { width } = directive.getBoundingClientRect();
 // directive.style.clip = `rect(0px, ${containerWidth}px, 55px, 0px)`;
};


const DragHandle = sortableHandle(() => <span className="drag-handle" />);
const SortableItem = sortableElement(
  ({ value, index, lastItem, reArrange, onSortEnd, handleDelete }) => {
    return (
      <React.Fragment>
        {
          <div id="directive-container" className="directive-container">
            {reArrange ? (
              <DirectiveCard
                heading={`Directive #${index+1}`}
                dragBtn={<DragHandle />}
                isCollapsable={true}
                headerButtons={[
                  <Input className="item-input" onChange={this.handleOrderChange} value={index + 1} />
                     ,   
                  <span className="lesson-arrange-arrows arrange-arrows">
                    {index > 0 && (
                      <span
                        onClick={() =>
                          onSortEnd({
                            oldIndex: index,
                            newIndex: Number(index) - 1
                          })
                        }
                        className="lesson-arrange-arrow-up"
                      />
                    )}
                    {Number(index) !== Number(lastItem) - 1 && (
                      <span
                        onClick={() =>
                          onSortEnd({
                            oldIndex: index,
                            newIndex: Number(index) + 1
                          })
                        }
                        className="lesson-arrange-arrow-down"
                      />
                    )}
                  </span>,
                  <DeleteButton
                    handleDelete={handleDelete}
                    index={'directive-container'+index}
                    item={value}
                  />
                ]}
                description={
                  <p>
                    <b>If</b> previous deck score = 72, <b>then</b> skip
                    relative deck 1{" "}
                  </p>
                }
              >
                <hr />
              </DirectiveCard>
            ) : (
              <DirectiveCard
                heading="Directive #1"
                isCollapsable={true}
                description={
                  <p>
                    <b>If</b> previous deck score = 72, <b>then</b> skip
                    relative deck 1{" "}
                  </p>
                }
              >
                <hr />
                <div>
                  <div>
                    <span className="condition">Conditions</span>
                    <span className="condition-link modal-link">
                      + Add New Condition
                    </span>
                  </div>
                  <div>
                    <span className="condition-tab">
                      Conditions
                      <DeleteButton
                        handleDelete={() => console.log("Delete Node")}
                        index={"asdasfsad1"}
                      />{" "}
                    </span>
                  </div>

                  <div className="conditions-block">
                    <Row>
                      <Col colSpan="3" md="3" lg="2" sm="2">
                        <label>Scope:</label>
                      </Col>
                      <Col colSpan="4" md="4" lg="4" sm="4">
                        <select>
                          <option>PREVIOUS</option>
                          <option>PREVIOUS_DECKS</option>
                          <option>SPECIFIC_DECKS</option>
                          <option>INTERACTION_BANK</option>
                          <option>ITEM_BANK</option>
                          <option>LESSON</option>
                          <option>NODE_RECENT</option>
                        </select>
                      </Col>
                      <Col colSpan="4" md="4" lg="4" sm="4">
                        <SearchableDropdown>
                          <Row>
                            <Form>
                              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <div className="author-lesson-checkbox">
                                  <Input type="checkbox" />
                                  <span class="checkmark" />
                                </div>
                              </FormGroup>
                            </Form>
                            <label>Deck Name</label>
                            <hr />
                          </Row>
                          <Row>
                            <Form>
                              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <div className="author-lesson-checkbox">
                                  <Input type="checkbox" />
                                  <span class="checkmark" />
                                </div>
                              </FormGroup>
                            </Form>
                            <label>Deck Name</label>
                            <hr />
                          </Row>
                          <Row>
                            <Form>
                              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <div className="author-lesson-checkbox">
                                  <Input type="checkbox" />
                                  <span class="checkmark" />
                                </div>
                              </FormGroup>
                            </Form>
                            <label>Deck Name</label>
                            <hr />
                          </Row>
                          <Row>
                            <Form>
                              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <div className="author-lesson-checkbox">
                                  <Input type="checkbox" />
                                  <span class="checkmark" />
                                </div>
                              </FormGroup>
                            </Form>
                            <label>Deck Name</label>
                            <hr />
                          </Row>
                          <Row>
                            <Form>
                              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <div className="author-lesson-checkbox">
                                  <Input type="checkbox" />
                                  <span class="checkmark" />
                                </div>
                              </FormGroup>
                            </Form>
                            <label>Deck Name</label>
                            <hr />
                          </Row>
                        </SearchableDropdown>
                      </Col>
                    </Row>
                    <Row>
                      <Col colSpan="3" md="3" lg="2" sm="2">
                        <label>Variable:</label>
                      </Col>
                      <Col colSpan="4" md="4" lg="4" sm="4">
                        <select>
                          <option>SCORE</option>
                        </select>
                      </Col>
                    </Row>
                    <Row>
                      <Col colSpan="3" md="3" lg="2" sm="2">
                        <label>Comparison</label>
                      </Col>
                      <Col colSpan="4" md="4" lg="4" sm="4">
                        <select>
                          <option>{">"}</option>
                          <option>{"<"}</option>
                          <option>{"=="}</option>
                          <option>{">="}</option>
                          <option>{"<="}</option>
                        </select>
                      </Col>
                    </Row>
                    <Row>
                      <Col colSpan="3" md="3" lg="2" sm="2">
                        <label>Value</label>
                      </Col>
                      <Col colSpan="4" md="4" lg="4" sm="4">
                        <Input defaultValue="72" />
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                      <Col colSpan="2" sm="2" md="3" lg="2">
                        <label>Gate:</label>
                      </Col>
                      <Col colSpan="10">
                        <select>
                          <option>AND</option>
                          <option>OR</option>
                          <option>NOT</option>
                        </select>
                      </Col>
                    </Row>
                    <Row>
                      <Col colSpan="2" sm="2" md="1" lg="2">
                        <label>Action:</label>
                      </Col>
                      <Col colSpan="4" sm="4" md="4" lg="4">
                        <select>
                          <option>GOTO</option>
                          <option>GOTO_THEN</option>
                          <option>SKIP_RELATIVE</option>
                          <option>SKIP_ABSOLUTE</option>
                        </select>
                      </Col>
                      <Col colSpan="4" sm="4" md="4" lg="4">
                        <Input
                          type="number"
                          placeholder="Select Desk"
                          defaultValue="asd"
                        />
                      </Col>
                    </Row>
                    <Button className="lesson-action-btn">
                      + Create Directive
                    </Button>
                  </div>
                </div>
              </DirectiveCard>
            )}
          </div>
        }
      </React.Fragment>
    );
  }
);
const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

export default class AddDecks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reArrangeActive: false,
      directives: []
    };
  }
  componentDidMount() {
    let directives = [];
    for (let i = 0; i < 7; i++) {
      directives.push({
        name: `Directive # ${i + 1}`,
        desc:
          "<p><b>If</b> previous deck score = 72, <b>then</b> skip relative deck 1</p>"
      });
    }
    this.setState({ directives });
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ directives }) => ({
        directives: arrayMove(directives, oldIndex, newIndex),
    }));
    console.log(oldIndex, newIndex)
  };
  rearrangeToggle = () => {
    this.setState({
      reArrangeActive: !this.state.reArrangeActive
    });
  };
  
  deleteRow = (item) => {
    console.log("delete item")
}
  render() {
    const { reArrangeActive } = this.state;
    return (
      <div className="deck-logic">
        <LessonCard
          iconClass="create-deck-logic"
          heading="Create Deck Logic"
          subHeading="Create Deck Logic for the Apostrophes Lesson Deck Bank"
          headerButtons={[
            <Button className="icon-btn" onClick={this.rearrangeToggle}>
              <i
                className={`icon-rearrange-icon-white ${
                  reArrangeActive ? "rearrange-active" : ""
                }`}
              />
            </Button>,
            <Button
              className={`add-btn`}
              onClick={() => console.log("Add Directive to Deck")}
            >
              + Add Directive
            </Button>
          ]}
          footerButtons={[
            <Button
              className="lesson-cancel-btn"
              onClick={() => this.props.onClose()}
            >
              Cancel Changes
            </Button>,
            <Button
              className="lesson-action-btn"
              onClick={() => this.props.createDeckLogic()}
            >
              + Add to Deck Bank
            </Button>
          ]}
        >
          <Row className="title-deck-logic">
            <Col colSpan="2" sm="2" md="1" lg="1">
              <label>Name:</label>
            </Col>
            <Col colSpan="10">
              <Input />
            </Col>
          </Row>
          <div className="items-bank-left-container">
            
            <SortableContainer
              onSortStart={handleSortStart}
              helperContainer={document.getElementById("drag-row-directive")}
              lockToContainerEdges
              useDragHandle
              lockAxis={"y"}
              helperClass={"directive-container dragging-directive"}
              onSortEnd={this.onSortEnd}
            ><div id="drag-row-directive" />
              {this.state.directives.map((value, index) => (
                <SortableItem
                  reArrange={this.state.reArrangeActive}
                  key={`item-${index}`}
                  index={index}
                  lastItem={this.state.directives.length}
                  value={value}
                  onSortEnd={this.onSortEnd}
                  handlePreview={this.handlePreview}
                  handleDelete={this.deleteRow}
                />
              ))}
            </SortableContainer>
          </div>
        </LessonCard>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/CreateDeckLogic.js